<section class="l-staticModal">
  <div class="staticModal">
    <app-nodata title="هذه الصفحة غير موجودة"> </app-nodata>
  </div>
</section>
